export enum SaveDialogResponseEnum {
  Save = 'save',
  ExitWithSave = 'exit',
  Cancel = 'cancel',
}
